
import { IWidgetDefinition } from '../../common/core';
import { QuerySubscribeData, widgetDefinition as QuerySubscribeWidgetDefinition } from '../query-subscribe/query-subscribe.data';
import { IFuseQuerySubscribeSettings } from './fuse-query-subscribe.settings';
var template = require("./template.html");
var styles = require("./styles.scss").toString();

class FuseQuerySubscribeData extends QuerySubscribeData {
  modalShown: boolean = false;
  showModal(modalShown) {
    this.modalShown = modalShown;

    if (modalShown) {
      var url = this.getPageUrl();
      console.log('Subscribe url: "' + url + '"');
    }
  }
  onSubscribed(success) {
    super.onSubscribed(success);
    if (success) {
      this.showModal(false);
    }
  }
  getSupportedWidgets() {
    var widgets = super.getSupportedWidgets();
    return [
      ...widgets,
      'fuse-search',
      'fuse-textfacet',
      'fuse-treefacet'
    ];
  }

  getSearchWidget() {
    var searchWidgets = this.widget.service.getAllWidgets().filter(function (w) {
      return w.type == 'fuse-search' || w.type == 'search';
    });
    if (searchWidgets.length) {
      if (searchWidgets.length > 1) {
        var matchedSearchW = searchWidgets.filter(function (sw) {
          if (sw && sw.widgetDiv && sw.widgetDiv.element && sw.widgetDiv.element.nativeElement && sw.widgetDiv.element.nativeElement.offsetParent) {
            return true;
          }
        })[0];
        if (matchedSearchW) {
          return matchedSearchW;
        }
      }
      return searchWidgets[0];
    }
  }
}

var widgetDefinition: IWidgetDefinition<FuseQuerySubscribeData, IFuseQuerySubscribeSettings, null> = {
  ...QuerySubscribeWidgetDefinition,
  init(widget) {
    widget.data = new FuseQuerySubscribeData(widget);
  },
  template: template,
  styles: styles
};

export { FuseQuerySubscribeData, widgetDefinition };
